import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_yvmjqjfezr: FaireBrandEntity = {
  token: "b_yvmjqjfezr",
  type: "brand",
  name: "SAYN PRO",
  avatarUrl:
    "https://cdn.faire.com/fastly/d379d11cb7df088ee0ecde6af14a73121e1c03f4d8fe5769b22c3b93cfdb2e07.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3fda5dbbcf0c1fd044032668d2398b14bfbf6f3f1c28604a15d9b1ca8a6241c3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d379d11cb7df088ee0ecde6af14a73121e1c03f4d8fe5769b22c3b93cfdb2e07.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3fda5dbbcf0c1fd044032668d2398b14bfbf6f3f1c28604a15d9b1ca8a6241c3.jpeg",
  location: "Miami, FL, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "Our mission here at Sayn Pro is to offer our salon and spa partners an unparalleled customer experience.\n• Orders Process Same-Day\n• Best In-Class Education\n• Customer Service Team On-Call to Help With All Needs\n• Exclusive Events For Brand Partners & Customers\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:46.581Z",
    importedBy: "entity-db-cli",
  },
};
